// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sectionTitle-title-5qj {\n    font-family: var(--venia-global-fontFamily-sansSerif);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "sectionTitle-title-5qj pb-4 border-b border-solid border-gray mb-7 text-black"
};
export default ___CSS_LOADER_EXPORT___;
